(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-site-header]');

  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('.kv-mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    document.querySelectorAll('.kv-reveal').forEach((item) => observer.observe(item));
  } else {
    document.querySelectorAll('.kv-reveal').forEach((item) => item.classList.add('is-visible'));
  }

  const visual = document.querySelector('[data-visual-tilt]');
  if (visual && !reducedMotion) {
    visual.addEventListener('pointermove', (event) => {
      const bounds = visual.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) * 100;
      const y = ((event.clientY - bounds.top) / bounds.height) * 100;
      visual.style.setProperty('--mx', `${x}%`);
      visual.style.setProperty('--my', `${y}%`);
    });
  }

  const fairStage = document.querySelector('[data-fair-stage]');
  const fairStageInner = fairStage?.querySelector('[data-fair-stage-inner]');
  const supportsFairTilt = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fairStage && fairStageInner && supportsFairTilt && !reducedMotion) {
    let fairTiltFrame = 0;
    fairStage.addEventListener('pointermove', (event) => {
      const bounds = fairStage.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) - .5;
      const y = ((event.clientY - bounds.top) / bounds.height) - .5;
      window.cancelAnimationFrame(fairTiltFrame);
      fairTiltFrame = window.requestAnimationFrame(() => {
        fairStage.style.setProperty('--fair-rx', `${(-y * 4.5).toFixed(2)}deg`);
        fairStage.style.setProperty('--fair-ry', `${(x * 6.5).toFixed(2)}deg`);
      });
    });
    const resetFairTilt = () => {
      window.cancelAnimationFrame(fairTiltFrame);
      fairStage.style.setProperty('--fair-rx', '0deg');
      fairStage.style.setProperty('--fair-ry', '0deg');
    };
    fairStage.addEventListener('pointerleave', resetFairTilt);
    fairStage.addEventListener('pointercancel', resetFairTilt);
  }

  document.querySelectorAll('.kv-button').forEach((button) => {
    button.addEventListener('pointerdown', (event) => {
      if (reducedMotion) return;
      const bounds = button.getBoundingClientRect();
      const ripple = document.createElement('span');
      ripple.className = 'kv-ripple';
      ripple.style.left = `${event.clientX - bounds.left}px`;
      ripple.style.top = `${event.clientY - bounds.top}px`;
      button.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    });
  });

  const privacyDialog = document.querySelector('[data-privacy-dialog]');
  const openPrivacy = () => {
    if (!privacyDialog) return;
    if (typeof privacyDialog.showModal === 'function' && !privacyDialog.open) privacyDialog.showModal();
    else privacyDialog.setAttribute('open', '');
    document.documentElement.classList.add('kv-dialog-open');
  };
  const closePrivacy = () => {
    if (!privacyDialog) return;
    if (typeof privacyDialog.close === 'function' && privacyDialog.open) privacyDialog.close();
    else privacyDialog.removeAttribute('open');
    document.documentElement.classList.remove('kv-dialog-open');
  };
  document.querySelectorAll('a[href$="#datenschutz"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!privacyDialog) return;
      event.preventDefault();
      openPrivacy();
      if (window.location.hash !== '#datenschutz') history.replaceState(null, '', '#datenschutz');
    });
  });
  privacyDialog?.querySelector('[data-privacy-close]')?.addEventListener('click', closePrivacy);
  privacyDialog?.addEventListener('click', (event) => {
    if (event.target === privacyDialog) closePrivacy();
  });
  privacyDialog?.addEventListener('close', () => {
    document.documentElement.classList.remove('kv-dialog-open');
    if (window.location.hash === '#datenschutz') history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  });
  if (window.location.hash === '#datenschutz') openPrivacy();

  const successParams = new URLSearchParams(window.location.search);
  const ensureSuccessNoIndex = () => {
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.content = 'noindex,nofollow';
  };

  const partnerApplicationView = document.querySelector('[data-partner-application-view]');
  const partnerSuccessView = document.querySelector('[data-partner-success-view]');
  const partnerSuccessRequested = successParams.get('bewerbung') === 'erfolgreich';

  if (partnerApplicationView && partnerSuccessView) {
    partnerApplicationView.hidden = partnerSuccessRequested;
    partnerSuccessView.hidden = !partnerSuccessRequested;
    if (partnerSuccessRequested) {
      document.documentElement.classList.add('kv-partner-success-requested');
      document.body.classList.add('kv-partner-success-active');
      document.title = 'Bewerbung erfolgreich abgeschickt. · KUVENORA';
      ensureSuccessNoIndex();
      window.setTimeout(() => partnerSuccessView.querySelector('[data-partner-success-page]')?.focus({ preventScroll: true }), 80);
    }
  }

  const customerApplicationView = document.querySelector('[data-customer-application-view]');
  const customerSuccessView = document.querySelector('[data-customer-success-view]');
  const customerSuccessRequested = successParams.get('anfrage') === 'erfolgreich';

  if (customerApplicationView && customerSuccessView) {
    customerApplicationView.hidden = customerSuccessRequested;
    customerSuccessView.hidden = !customerSuccessRequested;
    if (customerSuccessRequested) {
      document.documentElement.classList.add('kv-customer-success-requested');
      document.body.classList.add('kv-customer-success-active');
      document.title = 'Küchenwunsch erfolgreich abgeschickt. · KUVENORA';
      ensureSuccessNoIndex();
      window.setTimeout(() => customerSuccessView.querySelector('[data-customer-success-page]')?.focus({ preventScroll: true }), 80);
    }
  }

  const partnerSuccessRedirect = document.querySelector('[data-partner-success-redirect]');
  if (partnerSuccessRedirect) {
    const successUrl = partnerSuccessRedirect.dataset.successUrl;
    if (successUrl) {
      window.setTimeout(() => window.location.replace(successUrl), 120);
    }
  }

  const customerSuccessRedirect = document.querySelector('[data-customer-success-redirect]');
  if (customerSuccessRedirect) {
    const successUrl = customerSuccessRedirect.dataset.successUrl;
    if (successUrl) {
      window.setTimeout(() => window.location.replace(successUrl), 120);
    }
  }

  const successTiltStage = document.querySelector('[data-success-tilt]');
  const successTiltSurface = successTiltStage?.closest('[data-customer-success-page]');
  if (successTiltStage && successTiltSurface && !reducedMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let successTiltFrame = 0;
    const resetSuccessTilt = () => {
      window.cancelAnimationFrame(successTiltFrame);
      successTiltStage.style.setProperty('--success-rx', '0deg');
      successTiltStage.style.setProperty('--success-ry', '0deg');
    };
    successTiltSurface.addEventListener('pointermove', (event) => {
      const bounds = successTiltSurface.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) - .5;
      const y = ((event.clientY - bounds.top) / bounds.height) - .5;
      window.cancelAnimationFrame(successTiltFrame);
      successTiltFrame = window.requestAnimationFrame(() => {
        successTiltStage.style.setProperty('--success-rx', `${(-y * 3.8).toFixed(2)}deg`);
        successTiltStage.style.setProperty('--success-ry', `${(x * 5.5).toFixed(2)}deg`);
      });
    });
    successTiltSurface.addEventListener('pointerleave', resetSuccessTilt);
    successTiltSurface.addEventListener('pointercancel', resetSuccessTilt);
  }

  const partnerForm = document.querySelector('.kv-partner-form');
  if (partnerForm) {
    const partnerSteps = Array.from(partnerForm.querySelectorAll('[data-form-step]'));
    if (!partnerSteps.length) {
      partnerForm.querySelector('[data-form-success]')?.focus();
    } else {
      const partnerProgressBar = partnerForm.querySelector('[data-progress-bar]');
      const partnerProgressLabel = partnerForm.querySelector('[data-progress-label]');
      const partnerProgressTitle = partnerForm.querySelector('[data-progress-title]');
      const partnerSummary = partnerForm.querySelector('[data-form-summary]');
      const partnerStepTitles = ['Studio & Kontakt', 'Region & Leistung', 'Zusammenarbeit', 'Prüfen & senden'];
      let partnerCurrentStep = partnerForm.querySelector('[data-server-errors]') ? 0 : 0;

      const partnerFieldValue = (name) => {
        const field = partnerForm.elements.namedItem(name);
        if (!field) return '—';
        if (typeof field.length === 'number' && !field.tagName) return field.value || '—';
        if (field.tagName === 'SELECT') return field.selectedOptions[0]?.textContent?.trim() || '—';
        return field.value?.trim() || '—';
      };

      const updatePartnerSummary = () => {
        if (!partnerSummary) return;
        const rows = [
          ['Studio', partnerFieldValue('contact[Unternehmen]')],
          ['Ansprechpartner', `${partnerFieldValue('contact[name]')} · ${partnerFieldValue('contact[email]')}`],
          ['Postleitzahl', partnerFieldValue('contact[Postleitzahl]')],
          ['Betreuungsgebiet', partnerFieldValue('contact[Betreuungsgebiet]')],
          ['Radius', partnerFieldValue('contact[Betreuungsradius]')],
          ['Leistungsmodell', partnerFieldValue('contact[Leistungsmodell]')],
          ['Budgetsegment', partnerFieldValue('contact[Budgetsegment]')],
          ['Kapazität', partnerFieldValue('contact[Kapazität pro Monat]')],
          ['Reaktionszeit', partnerFieldValue('contact[Reaktionszeit]')]
        ];
        partnerSummary.replaceChildren(...rows.map(([label, value]) => {
          const row = document.createElement('div');
          row.className = 'kv-summary__row';
          const key = document.createElement('span');
          key.textContent = label;
          const content = document.createElement('b');
          content.textContent = value;
          row.append(key, content);
          return row;
        }));
      };

      const setPartnerStep = (index, shouldFocus = true) => {
        partnerCurrentStep = Math.max(0, Math.min(index, partnerSteps.length - 1));
        partnerSteps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === partnerCurrentStep));
        if (partnerProgressBar) partnerProgressBar.style.width = `${((partnerCurrentStep + 1) / partnerSteps.length) * 100}%`;
        if (partnerProgressLabel) partnerProgressLabel.textContent = `Schritt ${partnerCurrentStep + 1} von ${partnerSteps.length}`;
        if (partnerProgressTitle) partnerProgressTitle.textContent = partnerStepTitles[partnerCurrentStep];
        if (partnerCurrentStep === partnerSteps.length - 1) updatePartnerSummary();
        if (shouldFocus) {
          partnerSteps[partnerCurrentStep]?.querySelector('legend')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        }
      };

      const validatePartnerStep = (index) => {
        const step = partnerSteps[index];
        const error = step?.querySelector('[data-step-error]');
        if (error) error.textContent = '';
        const controls = Array.from(step?.querySelectorAll('input, select, textarea') || []);
        const invalid = controls.find((control) => !control.checkValidity());
        if (invalid) {
          if (error) {
            error.textContent = invalid.validity.valueMissing
              ? 'Bitte vervollständigen Sie die markierten Pflichtangaben.'
              : 'Bitte prüfen Sie das Format Ihrer Eingabe.';
          }
          if (step.classList.contains('is-active')) invalid.reportValidity();
          return false;
        }
        return true;
      };

      partnerForm.querySelectorAll('[data-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (validatePartnerStep(partnerCurrentStep)) setPartnerStep(partnerCurrentStep + 1);
        });
      });
      partnerForm.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => setPartnerStep(partnerCurrentStep - 1));
      });
      partnerForm.addEventListener('submit', (event) => {
        for (let index = 0; index < partnerSteps.length; index += 1) {
          if (!validatePartnerStep(index)) {
            event.preventDefault();
            setPartnerStep(index, false);
            partnerSteps[index].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
            partnerSteps[index].querySelector('input:invalid, select:invalid, textarea:invalid')?.reportValidity();
            return;
          }
        }
        const submit = partnerForm.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Wird sicher übermittelt …';
        }
      });
      setPartnerStep(partnerCurrentStep, false);
    }
  }

  const fireworksCanvas = document.querySelector('[data-success-fireworks]');
  const fireworksReplay = document.querySelector('[data-fireworks-replay]');
  const fireworksView = fireworksCanvas?.closest('[data-partner-success-view],[data-customer-success-view]');
  const fireworksViewIsActive = !fireworksView || !fireworksView.hidden;
  if (fireworksCanvas && fireworksViewIsActive && !reducedMotion) {
    const fireworksContext = fireworksCanvas.getContext('2d', { alpha: true });
    if (fireworksContext) {
      const successPage = fireworksCanvas.closest('[data-success-page]');
      const cinematicFireworks = fireworksCanvas.dataset.fireworksMode === 'customer';
      const palette = [
        [255, 253, 248],
        [229, 190, 157],
        [184, 110, 71],
        [112, 174, 151],
        [221, 210, 190]
      ];
      const isCompact = window.matchMedia('(max-width: 760px)');
      const rockets = [];
      const particles = [];
      let canvasWidth = 0;
      let canvasHeight = 0;
      let pixelRatio = 1;
      let animationFrame = 0;
      let runStartedAt = 0;
      let lastFrameAt = 0;
      let lastLaunchAt = 0;
      let runToken = 0;

      const resizeFireworks = () => {
        const bounds = fireworksCanvas.getBoundingClientRect();
        canvasWidth = Math.max(1, bounds.width);
        canvasHeight = Math.max(1, bounds.height);
        pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        fireworksCanvas.width = Math.round(canvasWidth * pixelRatio);
        fireworksCanvas.height = Math.round(canvasHeight * pixelRatio);
      };

      const projectParticle = (point) => {
        const perspective = Math.max(620, canvasWidth * 0.58);
        const safeDepth = Math.max(-perspective + 90, point.z);
        const scale = perspective / (perspective + safeDepth);
        return {
          x: (point.x - canvasWidth / 2) * scale + canvasWidth / 2,
          y: (point.y - canvasHeight * 0.42) * scale + canvasHeight * 0.42,
          scale: Math.max(0.28, Math.min(scale, 2.35))
        };
      };

      const explodeFirework = (x, y, depth, color) => {
        const count = isCompact.matches ? (cinematicFireworks ? 58 : 44) : (cinematicFireworks ? 104 : 74);
        const burstStyle = cinematicFireworks
          ? ['sphere', 'sphere', 'ring', 'willow'][Math.floor(Math.random() * 4)]
          : 'sphere';
        for (let index = 0; index < count; index += 1) {
          const theta = Math.random() * Math.PI * 2;
          const phi = Math.acos((Math.random() * 2) - 1);
          const speed = burstStyle === 'willow' ? 1.15 + Math.random() * 3.05 : 1.4 + Math.random() * 3.7;
          const sinPhi = Math.sin(phi);
          const ringSpread = (Math.random() - .5) * .65;
          particles.push({
            x,
            y,
            z: depth,
            vx: burstStyle === 'ring' ? Math.cos(theta) * speed : Math.cos(theta) * sinPhi * speed,
            vy: burstStyle === 'ring' ? Math.sin(theta) * speed : Math.sin(theta) * sinPhi * speed,
            vz: burstStyle === 'ring' ? ringSpread * speed : Math.cos(phi) * speed * 1.6,
            color,
            life: 1,
            decay: (burstStyle === 'willow' ? 0.0058 : 0.008) + Math.random() * 0.007,
            gravity: (burstStyle === 'willow' ? 0.026 : 0.018) + Math.random() * 0.018,
            size: 1.25 + Math.random() * 1.8,
            sparkle: Math.random() * Math.PI * 2,
            trail: []
          });
        }
      };

      const launchFirework = (preferredX) => {
        const startX = canvasWidth * (0.18 + Math.random() * 0.64);
        const targetX = typeof preferredX === 'number' ? canvasWidth * preferredX : canvasWidth * (0.12 + Math.random() * 0.76);
        rockets.push({
          startX,
          x: startX,
          y: canvasHeight + 24,
          targetX,
          targetY: canvasHeight * (0.13 + Math.random() * 0.35),
          depth: -150 + Math.random() * 390,
          color: palette[Math.floor(Math.random() * palette.length)],
          progress: 0,
          duration: 680 + Math.random() * 420,
          curve: (Math.random() - 0.5) * canvasWidth * 0.13,
          trail: []
        });
      };

      const drawRocket = (rocket, deltaMs) => {
        rocket.progress = Math.min(1, rocket.progress + deltaMs / rocket.duration);
        const eased = 1 - ((1 - rocket.progress) ** 3);
        rocket.x = rocket.startX + (rocket.targetX - rocket.startX) * eased + Math.sin(rocket.progress * Math.PI) * rocket.curve;
        rocket.y = canvasHeight + 24 + (rocket.targetY - canvasHeight - 24) * eased;
        rocket.trail.unshift({ x: rocket.x, y: rocket.y });
        if (rocket.trail.length > 9) rocket.trail.pop();
        const [red, green, blue] = rocket.color;
        fireworksContext.save();
        fireworksContext.beginPath();
        rocket.trail.forEach((point, index) => {
          if (index === 0) fireworksContext.moveTo(point.x, point.y);
          else fireworksContext.lineTo(point.x, point.y);
        });
        fireworksContext.strokeStyle = `rgba(${red},${green},${blue},.62)`;
        fireworksContext.lineWidth = 1.5;
        fireworksContext.shadowColor = `rgb(${red},${green},${blue})`;
        fireworksContext.shadowBlur = 10;
        fireworksContext.stroke();
        fireworksContext.restore();
        return rocket.progress >= 1;
      };

      const drawParticle = (particle, frameScale) => {
        particle.trail.unshift({ x: particle.x, y: particle.y, z: particle.z });
        if (particle.trail.length > 6) particle.trail.pop();
        particle.vx *= 0.987 ** frameScale;
        particle.vy *= 0.987 ** frameScale;
        particle.vz *= 0.984 ** frameScale;
        particle.vy += particle.gravity * frameScale;
        particle.x += particle.vx * frameScale;
        particle.y += particle.vy * frameScale;
        particle.z += particle.vz * frameScale;
        particle.life -= particle.decay * frameScale;
        particle.sparkle += .24 * frameScale;
        const projected = projectParticle(particle);
        const [red, green, blue] = particle.color;
        const sparkleAlpha = cinematicFireworks ? .68 + Math.sin(particle.sparkle) * .32 : 1;
        fireworksContext.save();
        fireworksContext.beginPath();
        particle.trail.forEach((point, index) => {
          const trailPoint = projectParticle(point);
          if (index === 0) fireworksContext.moveTo(trailPoint.x, trailPoint.y);
          else fireworksContext.lineTo(trailPoint.x, trailPoint.y);
        });
        fireworksContext.strokeStyle = `rgba(${red},${green},${blue},${Math.max(0, particle.life * .48)})`;
        fireworksContext.lineWidth = Math.max(.45, particle.size * projected.scale * .62);
        fireworksContext.stroke();
        fireworksContext.beginPath();
        fireworksContext.arc(projected.x, projected.y, Math.max(.55, particle.size * projected.scale), 0, Math.PI * 2);
        fireworksContext.fillStyle = `rgba(${red},${green},${blue},${Math.max(0, particle.life * sparkleAlpha)})`;
        fireworksContext.shadowColor = `rgb(${red},${green},${blue})`;
        fireworksContext.shadowBlur = 11 * projected.scale;
        fireworksContext.fill();
        fireworksContext.restore();
        return particle.life <= 0;
      };

      const renderFireworks = (timestamp, token) => {
        if (token !== runToken) return;
        const elapsed = timestamp - runStartedAt;
        const deltaMs = Math.min(34, lastFrameAt ? timestamp - lastFrameAt : 16.7);
        const frameScale = deltaMs / 16.7;
        lastFrameAt = timestamp;
        fireworksContext.setTransform(1, 0, 0, 1, 0, 0);
        fireworksContext.clearRect(0, 0, fireworksCanvas.width, fireworksCanvas.height);
        fireworksContext.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        fireworksContext.globalCompositeOperation = 'lighter';

        const launchWindow = cinematicFireworks ? 10400 : 7900;
        const launchInterval = cinematicFireworks
          ? (isCompact.matches ? 1120 : 760)
          : (isCompact.matches ? 1450 : 1120);
        if (elapsed < launchWindow && timestamp - lastLaunchAt > launchInterval) {
          launchFirework();
          lastLaunchAt = timestamp;
        }
        for (let index = rockets.length - 1; index >= 0; index -= 1) {
          if (drawRocket(rockets[index], deltaMs)) {
            const rocket = rockets[index];
            explodeFirework(rocket.x, rocket.y, rocket.depth, rocket.color);
            rockets.splice(index, 1);
          }
        }
        for (let index = particles.length - 1; index >= 0; index -= 1) {
          if (drawParticle(particles[index], frameScale)) particles.splice(index, 1);
        }
        fireworksContext.globalCompositeOperation = 'source-over';

        if (elapsed < (cinematicFireworks ? 14200 : 10500) || rockets.length || particles.length) {
          animationFrame = requestAnimationFrame((nextTimestamp) => renderFireworks(nextTimestamp, token));
        } else {
          successPage?.classList.remove('is-fireworks-running');
        }
      };

      const startFireworks = () => {
        runToken += 1;
        cancelAnimationFrame(animationFrame);
        resizeFireworks();
        rockets.length = 0;
        particles.length = 0;
        runStartedAt = performance.now();
        lastFrameAt = 0;
        lastLaunchAt = runStartedAt - 1500;
        successPage?.classList.add('is-fireworks-running');
        if (cinematicFireworks) {
          launchFirework(0.18);
          launchFirework(0.5);
          launchFirework(0.82);
        } else {
          launchFirework(0.28);
          launchFirework(0.72);
        }
        animationFrame = requestAnimationFrame((timestamp) => renderFireworks(timestamp, runToken));
      };

      window.addEventListener('resize', resizeFireworks, { passive: true });
      fireworksReplay?.addEventListener('click', startFireworks);
      window.setTimeout(startFireworks, 260);
    }
  } else if (fireworksReplay) {
    fireworksReplay.hidden = true;
  }

  const form = document.querySelector('.kv-lead-form');
  if (!form) {
    document.querySelector('[data-form-success]')?.focus();
    return;
  }

  const steps = Array.from(form.querySelectorAll('[data-form-step]'));
  if (!steps.length) {
    document.querySelector('[data-form-success]')?.focus();
    return;
  }
  const progressBar = form.querySelector('[data-progress-bar]');
  const progressLabel = form.querySelector('[data-progress-label]');
  const progressTitle = form.querySelector('[data-progress-title]');
  const summary = form.querySelector('[data-form-summary]');
  const stepTitles = ['Deine Küche', 'Rahmen & Region', 'Dein Kontakt', 'Prüfen & senden'];
  const phoneInput = form.elements.namedItem('contact[phone]');
  const channelInput = form.elements.namedItem('contact[Kontaktweg]');
  let currentStep = form.querySelector('[data-server-errors]') ? 2 : 0;

  const fieldValue = (name) => {
    const field = form.elements.namedItem(name);
    if (!field) return '—';
    if (typeof field.length === 'number' && !field.tagName) {
      return field.value || '—';
    }
    if (field.tagName === 'SELECT') {
      return field.selectedOptions[0]?.textContent?.trim() || '—';
    }
    return field.value?.trim() || '—';
  };

  const updateSummary = () => {
    if (!summary) return;
    const rows = [
      ['Projekt', fieldValue('contact[Projektart]')],
      ['Stil', fieldValue('contact[Küchenstil]')],
      ['Form', fieldValue('contact[Küchenform]')],
      ['Budget', fieldValue('contact[Budget]')],
      ['Zeitpunkt', fieldValue('contact[Kaufzeitpunkt]')],
      ['Beratung', fieldValue('contact[Beratungsart]')],
      ['Region', fieldValue('contact[Postleitzahl]')],
      ['Kontakt', `${fieldValue('contact[first_name]')} · ${fieldValue('contact[email]')} · ${fieldValue('contact[Kontaktweg]')}`]
    ];
    summary.replaceChildren(...rows.map(([label, value]) => {
      const row = document.createElement('div');
      row.className = 'kv-summary__row';
      const key = document.createElement('span');
      key.textContent = label;
      const content = document.createElement('b');
      content.textContent = value;
      row.append(key, content);
      return row;
    }));
  };

  const syncConditionalFields = () => {
    if (!phoneInput || !channelInput) return;
    phoneInput.required = channelInput.value === 'Rückruf';
  };
  channelInput?.addEventListener('change', syncConditionalFields);

  const setStep = (index, shouldFocus = true) => {
    currentStep = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === currentStep));
    if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
    if (progressLabel) progressLabel.textContent = `Schritt ${currentStep + 1} von ${steps.length}`;
    if (progressTitle) progressTitle.textContent = stepTitles[currentStep];
    if (currentStep === steps.length - 1) updateSummary();
    if (shouldFocus) {
      steps[currentStep]?.querySelector('legend')?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    }
  };

  const validateStep = (index) => {
    syncConditionalFields();
    const step = steps[index];
    const error = step?.querySelector('[data-step-error]');
    if (error) error.textContent = '';
    const controls = Array.from(step?.querySelectorAll('input, select, textarea') || []);
    const invalid = controls.find((control) => !control.checkValidity());
    if (invalid) {
      if (error) {
        error.textContent = invalid.validity.valueMissing
          ? 'Bitte vervollständige die markierten Pflichtangaben.'
          : 'Bitte prüfe das Format deiner Eingabe.';
      }
      if (step.classList.contains('is-active')) invalid.reportValidity();
      return false;
    }
    return true;
  };

  form.querySelectorAll('[data-next]').forEach((button) => {
    button.addEventListener('click', () => {
      if (validateStep(currentStep)) setStep(currentStep + 1);
    });
  });
  form.querySelectorAll('[data-back]').forEach((button) => {
    button.addEventListener('click', () => setStep(currentStep - 1));
  });

  form.addEventListener('submit', (event) => {
    for (let index = 0; index < steps.length; index += 1) {
      if (!validateStep(index)) {
        event.preventDefault();
        setStep(index, false);
        steps[index].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        steps[index].querySelector('input:invalid, select:invalid, textarea:invalid')?.reportValidity();
        return;
      }
    }
    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Wird sicher übermittelt …';
    }
  });

  document.querySelectorAll('[data-prefill-style]').forEach((link) => {
    link.addEventListener('click', () => {
      const desired = link.dataset.prefillStyle;
      const choices = Array.from(form.elements.namedItem('contact[Küchenstil]') || []);
      const match = choices.find((choice) => choice.value === desired);
      if (match) match.checked = true;
      setStep(0, false);
    });
  });

  setStep(currentStep, false);
})();
